module.exports = __webpack_public_path__ + "static/media/Dilger,Libby.92481a56.png";